"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1963],{

/***/ 11913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Web": function() { return /* binding */ Web; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var _modules_core_components_Layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71684);



var Web = function(param) {
    var Component = param.Component, deviceMode = param.deviceMode, layout = param.layout, seoTags = param.seoTags, userProfile = param.userProfile, isApp = param.isApp, shouldReloadPage = param.shouldReloadPage, features = param.features, pageProps = param.pageProps, pencil = param.pencil, subNav = param.subNav;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_core_components_Layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        deviceMode: deviceMode,
        seoTags: seoTags,
        userProfile: userProfile,
        isApp: isApp,
        shouldReloadPage: shouldReloadPage,
        itemCounters: layout.itemCounters,
        features: features,
        pencil: pencil,
        subNav: subNav,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, pageProps))
    });
};


/***/ })

}]);